import { useTranslation } from 'react-i18next';
import { Select } from '@knack/asterisk-react';

import { type MultipleChoiceField } from '@/types/schema/fields';
import { type InputValueType } from '@/components/data-table/display/header/filters/Filters';

export function MultipleChoiceInputValue({
  defaultValue,
  onChange,
  field
}: InputValueType<MultipleChoiceField>) {
  const [t] = useTranslation();

  return (
    <Select
      onValueChange={(newValue) => {
        onChange(newValue);
      }}
      defaultValue={defaultValue}
    >
      <Select.Trigger
        placeholder={t('components.data_table.filtering.select')}
        className="w-full rounded-lg"
        data-testid="field-select"
      />
      <Select.Content>
        {field.format.options?.map(
          (operator) =>
            !!operator && (
              <Select.Item key={operator} value={operator}>
                {operator}
              </Select.Item>
            )
        )}
      </Select.Content>
    </Select>
  );
}
